import styled from 'styled-components'
import colorsOptions from '../stories/fundamentals/colors-styles/constants.js'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../stories/fundamentals/text-styles/constants.js'

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
`

export const DescriptionText = styled.p`
  color: ${colorsOptions.greys['grey-100']};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
`
